import { createApi } from '@reduxjs/toolkit/query/react'
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'
import { GraphQLClient } from 'graphql-request'
import { LocalStorageKey } from '../vendor/local';
import { fetchSession } from "../auth";
import { clearMfa } from 'utils/mfa';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL || 'http://localhost:3000/graphql';
export const client = new GraphQLClient(GRAPHQL_URL);
client.setHeader('X-Inspectify-App', 'web2');

// NOTE phil: this is a list of queries that should have the order_token header
//            otherwise the query can fail
const OrderTokenEnabledQueries = [
  'GetReport',
  'GetReportLean',
  'GetOrderByToken',
  'GetPermitReport',
  'GetOrderPropertyPhoto',
  'GetDownloadLinks',
  'GetOrderStakeholderInformation',
  'GetInspectionScopeItems',
  'GetAvailableOrderReports',
  'GetReportPrintHeaderInfo',
  'GetPhotoSphereAttachments',
  'GetInspectionFloorplans',
  'GetRehabProjects',
  'MutateFloorplanAnchors'
];

// Note amber: this is a list of queries and mutations that should have the onboarding_id header
const OnboardingIdEnabledQueries = [
  'MutateSurveyorOnboarding',
  'MutateInspectorOnboarding',
  'GetSurveyorOnboarding',
  'GetInspectorOnboarding',
];

// see:
// https://github.com/dotansimha/graphql-code-generator/blob/master/website/src/pages/plugins/typescript/typescript-rtk-query.mdx#setting-an-authentication-header-after-a-mutation
export const api = createApi({
  baseQuery: graphqlRequestBaseQuery({
    client,
    customErrors: ({ name, message, response }) => {
      return {
        name,
        message,
        status: response.status,
        code: response.errors?.[0]?.extensions?.code,
        errors: response.errors
      };
    },
    prepareHeaders: async (headers, { endpoint }) => {
      let token = localStorage.getItem(LocalStorageKey.Token) || window.appInjectedJwtToken || '';
      const tokenExp = localStorage.getItem(LocalStorageKey.TokenExp) || '';

      const mfaToken = localStorage.getItem(LocalStorageKey.MfaToken) || '';
      const mfaTokenExp = localStorage.getItem(LocalStorageKey.MfaTokenExp) || '';

      // refresh the token before executing the query if it's expired
      if (token && tokenExp && Date.now() > parseInt(tokenExp)) {
        await fetchSession(true);
        token = localStorage.getItem(LocalStorageKey.Token) || '';
      }

      // Clear the multi factor auth token if it's expired
      if (mfaToken && mfaTokenExp && Date.now() > parseInt(mfaTokenExp) * 1000) {
        clearMfa();
      }

      const orderToken = localStorage.getItem(LocalStorageKey.OrderToken) || '';
      const currentUser = localStorage.getItem(LocalStorageKey.SelectedContractor) || '';
      const onboardingId = localStorage.getItem(LocalStorageKey.OnboardingId) || '';

      if (currentUser) {
        headers.set('X-Inspectify-Behave-As', currentUser);
      }
      if (orderToken && OrderTokenEnabledQueries.includes(endpoint)) {
        headers.set('order_token', orderToken);
      }
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      if (mfaToken) {
        headers.set('X-Inspectify-MFA-Token', mfaToken)
      }
      if (onboardingId && OnboardingIdEnabledQueries.includes(endpoint)) {
        headers.set('onboarding_id', onboardingId);
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
});

